import React from 'react';
import { Box, Typography } from '@mui/material';
import { PageIndices } from '@/common/i-doc/i-doc.registry.ts';
import { PageCard } from '@components/common/PageCard.tsx';
import { PageHint } from '@components/common/PageHint.tsx';

// Дашборд експерта для продакт-менеджера (2026-10-10). Поки заготовка: що саме показувати продакту, визначаємо окремо.
export const PmExpertDashboardTab: React.FC = () => (
  <Box data-i-doc={PageIndices.PM_EXPERT_DASHBOARD}>
    <PageHint iDoc={PageIndices.PM_EXPERT_DASHBOARD} />
    <PageCard>
      <Box sx={{ p: 4, textAlign: 'center' }}>
        <Typography color="text.secondary">Дашборд експерта для продакта. Розділ у розробці.</Typography>
      </Box>
    </PageCard>
  </Box>
);
